module.exports = __webpack_public_path__ + "img/icone-ajustes.95c9cd68.svg";